import { CustomFeature } from '@/enums/custom-feature';
import { Permission } from '@/enums/permission';
import { Role } from '@/enums/role';
import RouteName from '@/enums/route-name';
import { FeatureName } from '@/types/feature-name';
import { Privileges } from '@/types/privileges';

const REQUIRED_PRIVILEGES: Record<FeatureName, Privileges> = {
    [RouteName.STORE2STORE]: {
        roles: [Role.GLS_ADMIN, Role.GLS_S2S_ADMIN, Role.STORE_ADMIN, Role.STORE_USER],
        permissions: [Permission.S2S_Shipment_Creation]
    },
    [RouteName.PICKUP]: {
        roles: [Role.GLS_ADMIN, Role.PICK_USER, Role.WEB_USER],
        permissions: [Permission.PU_create, Permission.PU_create_pickship, Permission.PU_create_pickreturn]
    },
    [RouteName.PARCEL_OVERVIEW]: {
        roles: [Role.GLS_ADMIN, Role.GLS_S2S_ADMIN, Role.STORE_USER, Role.STORE_ADMIN, Role.PICK_USER, Role.WEB_USER],
        permissions: [Permission.S2S_Shipment_Overview_Read_only]
    },
    [RouteName.STORE_MANAGEMENT]: {
        roles: [Role.GLS_ADMIN, Role.GLS_S2S_ADMIN, Role.STORE_ADMIN],
        permissions: [Permission.S2S_CRUD_store]
    },
    [RouteName.CREATE_SHIPMENT]: {
        roles: [Role.GLS_ADMIN, Role.WEB_USER],
        permissions: [Permission.Create_shipment]
    },
    [CustomFeature.RETURN_PARCEL_TO_REQUESTER]: {
        roles: [Role.GLS_ADMIN],
        permissions: [Permission.PU_create_pickreturn]
    }
};

export { REQUIRED_PRIVILEGES };
